export default __webpack_public_path__ + "static/media/home-icon-active.dc7681dc.webp";